const SKU = {
    list: (id:string) => `inventory/sku/store/${id}`,
    getById: (id:string) => `store/sku/${id}`,
}
export default SKU